<template>
  <div class="container" @click="onClick()">
    <div class="cover">
        <div class="cover-image img">
            <img :src="data.pic" class="img"/>
        </div>
        <!-- <div class="cover-state">
            <div>敬请期待</div>
        </div> -->
    </div>
    <div class="info name">
        
        <div v-if="isEn">{{data.eName || 'English Name'}}</div>
        <div v-else>{{data.title}}</div>
        <!-- <div>
            <span class="count-people">9847</span>
            <span class="count-subfix">人已参加</span>
        </div> -->
    </div>
  </div>
</template>

<script>
import hsimage from '../common/hsimage.vue'

export default {
    name:"ActivityName",
    props:{
        data:Object
    },
    components:{
        hsimage
    },
    data(){
        return{
            isEn: false
        }
    },
    mounted(){
        let la = localStorage.getItem('locale')
        this.isEn = (la == 'en')
        // console.log("isEnlish:",this.isEn)
        this.$bus.$on('LANGUAGE_CHEANGED',this.onLanguagechanged)
    },
    beforeDestroy(){
        this.$bus.$off('LANGUAGE_CHEANGED')
    },
    methods:{
        onClick(){
            this.$emit('itemClick',this.data)
        },
        onLanguagechanged(val){
            this.isEn = (val == 'en')
        }
    }
}
</script>

<style scoped>
    .container{
        width: 100%;
        height: auto;
        min-width: 270px;
        min-height: 243px;
        border-radius: 24px;
        background-color: #D2F4F2;
        cursor: pointer;
    }
    .cover{
        position: relative;
        height: 225px;
        border-radius: 24px 24px 0px 0px;
    }
    .cover-image{
        position:absolute;
       

    }
    .img{
        border-radius: 24px 24px 0px 0px;
        width: 100%;
        height: 100%;
    }
    .cover-state{
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-items: center;
        align-content: center;
    }

    .info{
        padding-left: 14px;
        padding-right: 14px;
        height: 48px;
        background-color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 0px 0px 24px 24px;

    }
    .name{
        color: #000000;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
    }
    .count-people{
        color: #00A1FE;
        font-size: 14px;
        text-align: left;
    }
    .count-subfix{
        color: #888888;
        font-size: 14px;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/activity_card.vue